import { graphqlRequest } from '../urql';

import {
  loginUserMutation,
  saveFavoritesMutation,
  deleteFavoritesMutation,
  resumeSessionMutation
} from './mutations';

import { isOk } from '@/common/utils';
import { getCommunityIdFromBookIdQuery } from './queries';

export const logInUserApi = async (email, password, bookId) => {
  const res = await graphqlRequest(loginUserMutation, {
    email,
    password
  });

  const resCommunity = await graphqlRequest(getCommunityIdFromBookIdQuery, {
    bookId
  });

  if (!isOk(res) || !isOk(resCommunity)) return;

  const user = res.data.login_user;
  const communityId = resCommunity?.data?.book?.community_id;

  const communityUserId =
    user.communities_users.find(
      community_user =>
        community_user && community_user.community.id === communityId
    )?.id || null;

  return {
    token: user.token,
    communityUserId
  };
};

export const resumSessionApi = async sessionToken => {
  const res = await graphqlRequest(resumeSessionMutation, { sessionToken });

  if (!isOk(res) || !res.data.token_session) return {};

  const { token, context, communities_users } = res.data.token_session;

  const bookId = context.book_id;
  const resCommunity = await graphqlRequest(getCommunityIdFromBookIdQuery, {
    bookId
  });

  if (!isOk(resCommunity)) return {};
  const communityId = resCommunity.data.book.community_id;

  const communityUserId = communities_users.find(
    community_user => community_user.community.id === communityId
  )?.id;

  return {
    token,
    bookId: context.book_id,
    communityUserId: communityUserId || null,
    origin_url: context.origin_url
  };
};

/**
 * Save layout id to favorites
 *
 * @param   {Number | String} id  id of selected layout
 * @returns {Object}              mutation result
 */
export const saveToFavoritesApi = async id => {
  return graphqlRequest(saveFavoritesMutation, { id });
};

/**
 * delete layout id from favorites
 *
 * @param   {Number | String} id  id of selected layout
 * @returns {Object}              mutation result
 */
export const deleteFavoritesApi = async id => {
  return graphqlRequest(deleteFavoritesMutation, { id });
};
